import noticeImg from '@wwe-portal/ui/public/assets/images/common/notice.svg';

export const LeaveGameDialogHead = () => {
  return (
    <div className="relative flex h-full w-full items-center justify-center">
      <img alt="success" height="100%" src={noticeImg} width="100%" />
    </div>
  );
};
